import { Datatype } from '../../../../datatype/Datatype';
import { createConditionOperator } from '../../IConditionOperator';

/**
 * Versione di "not defined" per i campi array.
 */
export const ConditionOperatorEmptyItemType = createConditionOperator({
  code: 'emptyItem',
  label: 'è vuoto',
  description: 'È vuoto',
  args: [],
  allowsField: field => field.type === Datatype.Array,
  compare(value: any) {
    if (!value) return true;
    return Array.isArray(value) && value.length === 0;
  },
});
